import React, { Component } from 'react';
import socketIOClient from 'socket.io-client';
import config from '../config'

class Sockertconnector extends Component {

  componentWillReceiveProps(nextProps){
  }

  componentWillUnmount(){
    let com = this;
    this.socket.emit('disconnect',function(){
      com.props.changeSocketStatus(false);
    })
  }

  render() {
    if( !this.socket && !this.props.app.main_loading ){
      let com = this;
      this.socket = socketIOClient(config.baseUrl);
      const appData = JSON.parse(localStorage.getItem('appData'));

      this.socket.on('record_create', function(data){
        com.props.creatSocketRecord(data)
      });

      this.socket.on('record_update', function(data){
        com.props.updateSocketRecord(data)
      });

      this.socket.on('record_delete', function(data){
        com.props.deleteSocketRecord(data)
      });


      this.socket.on('connect', function(data){
        com.props.changeSocketStatus(true);
      });

      this.socket.on('disconnect', function(data){
        com.props.changeSocketStatus(false);
      });

      this.socket.emit('subscribe', {'Access-Token': appData.access_token});
    }
    return (
      <div></div>
    );
  }
}

export default Sockertconnector;
